/* Cabana Club theme.js — runs after DOMContentLoaded */
(function () {
  'use strict';

  function init() {
    /* ====== Drawers ====== */
    function openDrawer(el) {
      closeAllDrawers();
      el.classList.add('is-open');
      el.setAttribute('aria-hidden', 'false');
      var overlay = document.querySelector('[data-overlay]');
      if (overlay) overlay.classList.add('is-active');
      document.body.style.overflow = 'hidden';
    }
    function closeAllDrawers() {
      document.querySelectorAll('.ce-drawer, .cabana-filters.is-open').forEach(function (d) {
        d.classList.remove('is-open');
        d.setAttribute('aria-hidden', 'true');
      });
      var overlay = document.querySelector('[data-overlay]');
      if (overlay) overlay.classList.remove('is-active');
      document.body.style.overflow = '';
    }

    function bindDrawer(triggerAttr, drawerAttr) {
      document.querySelectorAll('[' + triggerAttr + ']').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          var drawer = document.querySelector('[' + drawerAttr + ']');
          if (drawer) openDrawer(drawer);
        });
      });
    }
    bindDrawer('data-open-menu', 'data-drawer-menu');
    bindDrawer('data-open-search', 'data-drawer-search');
    bindDrawer('data-open-cart', 'data-drawer-cart');

    document.querySelectorAll('[data-close-drawer], [data-overlay]').forEach(function (el) {
      el.addEventListener('click', closeAllDrawers);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAllDrawers();
    });

    /* ====== Sticky header ====== */
    var header = document.querySelector('[data-header]');
    if (header) {
      window.addEventListener('scroll', function () {
        header.classList.toggle('is-scrolled', window.scrollY > 8);
      }, { passive: true });
    }

    /* ====== PDP variant select ====== */
    document.querySelectorAll('.cabana-pdp__form').forEach(function (form) {
      var select = form.querySelector('.cabana-pdp__variant-select');
      if (!select) return;
      form.addEventListener('change', function () {
        var values = {};
        form.querySelectorAll('.cabana-pdp__option-input:checked').forEach(function (input) {
          var match = input.name.match(/options\[(.+)\]/);
          if (match) values[match[1]] = input.value;
        });
        var productData = document.querySelector('script[id^="ProductJson-"]');
        if (!productData) return;
        try {
          var product = JSON.parse(productData.textContent);
          var match = product.variants.find(function (v) {
            return product.options.every(function (opt, i) {
              return v.options[i] === values[opt];
            });
          });
          if (match) {
            select.value = match.id;
            var atc = form.querySelector('.cabana-pdp__atc');
            if (atc) {
              atc.disabled = !match.available;
              atc.textContent = match.available ? 'In winkelmand' : 'Uitverkocht';
            }
          }
        } catch (e) {}
      });
    });

    /* ====== AJAX add to cart + open cart drawer ====== */
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (form.matches && form.matches('form[action*="/cart/add"]')) {
        e.preventDefault();
        var fd = new FormData(form);
        fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function () {
            if (window.cabanaCartRefresh) return window.cabanaCartRefresh({ open: true });
          })
          .catch(function () { form.submit(); });
      }
    });

    /* ====== Mobile filter drawer toggle ====== */
    function isMobile() { return window.matchMedia('(max-width: 768px)').matches; }
    function updateMobileFilterUI() {
      var head = document.querySelector('.cabana-filters__head');
      var apply = document.querySelector('.cabana-filter__apply');
      var btn = document.querySelector('[data-open-filters]');
      if (head) head.style.display = isMobile() ? 'flex' : 'none';
      if (apply) apply.style.display = isMobile() ? 'block' : 'none';
      if (btn) btn.style.display = isMobile() ? 'inline-flex' : 'none';
    }
    updateMobileFilterUI();
    window.addEventListener('resize', updateMobileFilterUI);

    document.querySelectorAll('[data-open-filters]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var f = document.querySelector('[data-filters]');
        if (f) {
          f.classList.add('is-open');
          var overlay = document.querySelector('[data-overlay]');
          if (overlay) overlay.classList.add('is-active');
          document.body.style.overflow = 'hidden';
        }
      });
    });
    document.querySelectorAll('[data-close-filters]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var f = document.querySelector('[data-filters]');
        if (f) {
          f.classList.remove('is-open');
          var overlay = document.querySelector('[data-overlay]');
          if (overlay) overlay.classList.remove('is-active');
          document.body.style.overflow = '';
        }
      });
    });

    /* ====== Hide sticky ATC when main ATC visible ====== */
    var stickyAtc = document.querySelector('[data-sticky-atc]');
    var mainAtc = document.querySelector('.cabana-pdp__atc');
    if (stickyAtc && mainAtc && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          stickyAtc.style.transform = entry.isIntersecting ? 'translateY(100%)' : 'translateY(0)';
          stickyAtc.style.transition = 'transform .25s ease';
        });
      });
      observer.observe(mainAtc);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ====== Product grid scroll indicator ====== */
(function () {
  function initScrollbar() {
    document.querySelectorAll('[data-grid-scrollbar]').forEach(function (bar) {
      var thumb = bar.querySelector('[data-thumb]');
      if (!thumb) return;
      var section = bar.closest('section');
      if (!section) return;
      var grid = section.querySelector('.product-grid');
      if (!grid) return;

      function update() {
        var rect = grid.getBoundingClientRect();
        var vh = window.innerHeight;
        // Progress: when grid top reaches viewport bottom = 0, when grid bottom reaches viewport top = 1
        var total = rect.height + vh;
        var scrolled = vh - rect.top;
        var pct = Math.max(0, Math.min(1, scrolled / total));
        thumb.style.transform = 'scaleX(' + (0.25 + pct * 0.75) + ')';
      }
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollbar);
  } else {
    initScrollbar();
  }
})();

/* ====== Quick add to cart (PDP-less) ====== */
(function () {
  function initQuickAdd() {
    document.querySelectorAll('[data-quick-add]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var variantId = btn.getAttribute('data-quick-add');
        if (!variantId) return;
        btn.disabled = true;
        var originalHtml = btn.innerHTML;
        btn.innerHTML = '…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
        .then(function (r) { return r.json(); })
        .then(function () {
          btn.innerHTML = '✓';
          setTimeout(function () { btn.innerHTML = originalHtml; btn.disabled = false; }, 1200);
          if (window.cabanaCartRefresh) return window.cabanaCartRefresh({ open: true });
        })
        .catch(function () { btn.innerHTML = originalHtml; btn.disabled = false; });
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initQuickAdd);
  } else {
    initQuickAdd();
  }
})();

/* ====== Product carousel scroll progress ====== */
(function () {
  function initCarousel() {
    document.querySelectorAll('[data-pgrid]').forEach(function (section) {
      var track = section.querySelector('[data-pcarousel-track]');
      var bar = section.querySelector('[data-pcarousel-bar]');
      if (!track || !bar) return;

      function update() {
        var max = track.scrollWidth - track.clientWidth;
        if (max <= 0) {
          bar.style.width = '100%';
          return;
        }
        var pct = track.scrollLeft / max;
        var visibleRatio = track.clientWidth / track.scrollWidth;
        bar.style.width = (visibleRatio * 100) + '%';
        bar.style.transform = 'translateX(' + (pct * (100 - visibleRatio * 100)) + '%)';
      }
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCarousel);
  } else {
    initCarousel();
  }
})();

/* ====== Quick-add: + opens size picker ====== */
(function () {
  function initPcardQuickAdd() {
    document.querySelectorAll('[data-pcard-quick-trigger]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var card = btn.closest('.pcard');
        if (!card) return;
        // Close other open cards
        document.querySelectorAll('.pcard.is-quick-open').forEach(function (other) {
          if (other !== card) other.classList.remove('is-quick-open');
        });
        card.classList.toggle('is-quick-open');
        var sizes = card.querySelector('[data-pcard-sizes]');
        if (sizes) sizes.setAttribute('aria-hidden', card.classList.contains('is-quick-open') ? 'false' : 'true');
      });
    });

    // Size click → add to cart
    document.addEventListener('click', function (e) {
      var sizeBtn = e.target.closest('.pcard__size');
      if (!sizeBtn || sizeBtn.disabled) return;
      e.preventDefault();
      e.stopPropagation();
      var variantId = sizeBtn.getAttribute('data-variant-id');
      if (!variantId) return;
      var originalText = sizeBtn.textContent;
      sizeBtn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(function (r) { return r.json(); })
      .then(function () {
        sizeBtn.classList.add('is-added');
        sizeBtn.textContent = '✓';
        setTimeout(function () {
          sizeBtn.classList.remove('is-added');
          sizeBtn.textContent = originalText;
          sizeBtn.disabled = false;
          var card = sizeBtn.closest('.pcard');
          if (card) card.classList.remove('is-quick-open');
        }, 1500);
        if (window.cabanaCartRefresh) return window.cabanaCartRefresh({ open: true });
      })
      .catch(function () { sizeBtn.disabled = false; sizeBtn.textContent = originalText; });
    });

    // Click outside to close quick-add panel
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.pcard')) {
        document.querySelectorAll('.pcard.is-quick-open').forEach(function (c) {
          c.classList.remove('is-quick-open');
        });
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPcardQuickAdd);
  } else {
    initPcardQuickAdd();
  }
})();

/* ====== PDP — size picker + ATC sync ====== */
(function () {
  function initPDP() {
    document.querySelectorAll('[data-pdp-form]').forEach(function (form) {
      var sizeBtns = form.querySelectorAll('.pdp__size');
      var variantInput = form.querySelector('[data-pdp-variant-input]');
      var atc = form.querySelector('[data-pdp-atc]');

      sizeBtns.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          if (btn.disabled) return;
          e.preventDefault();
          sizeBtns.forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          var variantId = btn.getAttribute('data-variant-id');
          if (variantInput && variantId) variantInput.value = variantId;
        });
      });

      // AJAX submit
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var fd = new FormData(form);
        if (atc) { atc.disabled = true; atc.textContent = 'Bezig…'; }
        fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (item) {
            if (item.status) throw item;
            if (atc) {
              atc.textContent = 'Toegevoegd ✓';
              atc.disabled = false;
              setTimeout(function () {
                atc.textContent = 'In winkelmand';
              }, 1500);
            }
            if (window.cabanaCartRefresh) return window.cabanaCartRefresh({ open: true });
          })
          .catch(function (err) {
            if (atc) {
              atc.textContent = err.description || 'Fout — probeer opnieuw';
              atc.disabled = false;
              setTimeout(function () { atc.textContent = 'In winkelmand'; }, 2000);
            }
          });
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPDP);
  } else {
    initPDP();
  }
})();

/* ====== Cart drawer refresh (Section Rendering API) ====== */
(function () {
  function openCart() {
    var drawer = document.querySelector('[data-drawer-cart]');
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    var overlay = document.querySelector('[data-overlay]');
    if (overlay) overlay.classList.add('is-active');
    document.body.style.overflow = 'hidden';
  }

  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.setAttribute('data-cart-count', n);
      if (el.classList.contains('ce-header__cart-count')) {
        el.style.display = n > 0 ? '' : 'none';
      }
    });
  }

  // Re-render the cart drawer body from the live section markup so the
  // contents always reflect the real cart (fixes "empty cart" after add).
  function refreshCart(opts) {
    opts = opts || {};
    var drawer = document.querySelector('[data-drawer-cart]');
    var section = (drawer && drawer.getAttribute('data-cart-section')) || 'header';
    return fetch('/?section_id=' + encodeURIComponent(section), { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newBody = doc.querySelector('[data-cart-body]');
        var curBody = document.querySelector('[data-cart-body]');
        if (newBody && curBody) curBody.innerHTML = newBody.innerHTML;
        var newCount = doc.querySelector('.ce-header__cart-count');
        if (newCount) setCount(parseInt(newCount.textContent, 10) || 0);
        if (opts.open) openCart();
      })
      .catch(function () { if (opts.open) openCart(); });
  }

  window.cabanaCartRefresh = refreshCart;
  window.cabanaCartOpen = openCart;

  function changeLine(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return refreshCart(); });
  }

  // Quantity steppers + remove (event-delegated so they survive re-render)
  document.addEventListener('click', function (e) {
    var remove = e.target.closest('[data-cart-remove]');
    if (remove) {
      e.preventDefault();
      changeLine(remove.getAttribute('data-key'), 0);
      return;
    }
    var up = e.target.closest('[data-qty-up]');
    if (up) {
      e.preventDefault();
      var numUp = up.closest('.ce-cart__qty').querySelector('.ce-cart__qty-num');
      changeLine(up.getAttribute('data-key'), (parseInt(numUp.textContent, 10) || 0) + 1);
      return;
    }
    var down = e.target.closest('[data-qty-down]');
    if (down) {
      e.preventDefault();
      var numDown = down.closest('.ce-cart__qty').querySelector('.ce-cart__qty-num');
      var q = (parseInt(numDown.textContent, 10) || 0) - 1;
      changeLine(down.getAttribute('data-key'), q < 0 ? 0 : q);
      return;
    }
  });
})();
